import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { EKanbanCardProperty, IGetState, TBoardId, TKanbanCardProperty } from '../../../../../../../../types/types';
import {
    boardUserMetaSetCardPreviewHiddenProperties
} from '../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewHiddenProperties';
import {
    getBoardUserMetaCardPreviewHiddenProperties
} from '../../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewHiddenProperties';
import { getToggledProperties } from '../selectors/getToggledProperties';
import {
    SegmentCardEvent, SegmentCardOptions, SegmentCardOptionStatusValue,
    SegmentCardPreviewSettingsSourceValue
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    boardUserMetaSetCardPreviewCustomProperties
} from '../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewCustomProperties';
import {
    getBoardUserMetaCardPreviewCustomProperties
} from '../../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewCustomProperties';

export function onToggle (
    boardId: TBoardId,
    key: TKanbanCardProperty,
): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const properties = getBoardUserMetaCardPreviewHiddenProperties(state, boardId);
        const newProperties = getToggledProperties(properties, key);
        let isOn = false;
        if (newProperties.length > properties.length) {
            isOn = true;
        }
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREVIEW_SETTING_SELECTED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardPreviewSettingsSourceValue.CARD_PREVIEW
        }, [
            {
                name: SegmentCardOptions.TYPE,
                value: key.toLowerCase().replace('_', ''),
            },
            {
                name: SegmentCardOptions.STATUS,
                value: isOn ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF,
            }
        ]));
        if (key.includes(EKanbanCardProperty.CUSTOM_PROPERTIES)) {
            let customProperties = [...getBoardUserMetaCardPreviewCustomProperties(state, boardId)];
            if (customProperties.includes(key)) {
                customProperties = customProperties.filter(item => item !== key);
            } else {
                customProperties.push(key);
            }
            dispatch(boardUserMetaSetCardPreviewCustomProperties(boardId, customProperties));
        } else {
            dispatch(boardUserMetaSetCardPreviewHiddenProperties(boardId, newProperties));
        }
    };
    return action;
}
